<div *ngIf="invoice" class="form-group row" style="margin: 3px">
    <div *ngIf="invoice" class="col-sm-12 pb-1">
        <div class="btn-toolbar mx-0 mb-0 mt-0">
            <div class="d-flex flex-row flex-fill">
                <div>
                    <button (click)="save()" class="btn btn-sm btn-primary mr-2" *ngIf="hasChanges()">Save</button>
                    <button (click)="cancel()" class="btn btn-sm btn-success mr-2" *ngIf="hasChanges()">Cancel</button>
                    <button (click)="close()" class="btn btn-sm btn-primary mr-2" *ngIf="!hasChanges()">Close</button>
                    <button (click)="print()" class="btn btn-sm btn-success mr-1" *ngIf="!hasChanges()">Print</button>
                    <button (click)="email()" class="btn btn-sm btn-success mr" *ngIf="!hasChanges()">Email</button>
                </div>
                <ng-container>
                    <label class="mt-2 ml-4">Create Date</label>
                    <dx-date-box class="ml-3" [(value)]="invoice.created" width="125px" height="32" ></dx-date-box>
                </ng-container>
                <div>
                    <button class="btn btn-sm btn-secondary mt-1 ml-4" (click)="editBilling()" [disabled]="!selectedJob">Edit Billing Address</button>
                </div>
                <div  *ngIf="invoice?.paid" class="admin-invoice-banner ml-auto mr-auto">
                    <div class="invoice-box">
                        Invoice Paid - {{ invoice?.paid | date : 'MM/dd/yyyy' }}
                    </div>
                </div>
            </div>
        </div>

        <dx-form *ngIf="invoice" [formData]="invoice" [colCount]="3" validationGroup="mainValidationGroup">
            <dxi-item itemType="group" caption="Job Information">
                <dxi-item dataField="invoiceNumber" [label]="{ text: 'Invoice #' }"></dxi-item>
                <dxi-item dataField="pONumber" [label]="{ text: 'PO Number' }" [editorOptions]="{ readOnly: false }"> </dxi-item>
                <dxi-item [label]="{ text: 'Job' }" *ngIf="invoice">
                    <div *dxTemplate>
                        <dx-select-box
                            [(value)]="invoice.jobId"
                            [dataSource]="jobsDS"
                            valueExpr="id"
                            displayExpr="displayName"
                            searchEnabled="true"
                            searchMode="startswith"
                            (onValueChanged)="jobSelectionChanged($event)"
                            [readOnly]="readOnly"
                        >
                        </dx-select-box>
                    </div>
                    <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" caption="Customer Info">
                <dxi-item dataField="job.customerName" [label]="{ text: 'Name' }" [disabled]="true"> </dxi-item>
                <dxi-item *ngIf="invoice.job?.contactName" dataField="job.contactName" [label]="{ text: 'Contact' }" [disabled]="true"> </dxi-item>
                <dxi-item dataField="job.email" [label]="{ text: 'Email' }" [disabled]="true"> </dxi-item>
                <dxi-item dataField="job.cellPhone" [label]="{ text: 'Phone' }" [disabled]="true"> </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" caption="Address">
                <dxi-item [label]="{ text: 'Location' }" *ngIf="invoice">
                    <div *dxTemplate>
                        <h3 class="mt-0 mb-1">{{ selectedJob?.customerName }}</h3>
                        <div>{{ selectedJob?.jobAddress1 }}</div>
                        <div>{{ selectedJob?.jobAddress2 }}</div>
                        <div>
                            {{ selectedJob?.jobCity?.trim() }}{{ selectedJob?.jobCity && ', ' }}
                            {{ selectedJob?.jobState }}
                            {{ selectedJob?.jobZip }}
                        </div>
                        <div>{{ selectedJob?.cellPhone }}</div>
                    </div>
                </dxi-item>
                <dxi-item [label]="{ text: 'Billing' }" *ngIf="invoice">
                    <div *dxTemplate>
                        <h3 class="mt-0 mb-1">{{ selectedJob?.shipCompanyName }}</h3>
                        <h3 class="mt-0 mb-1">{{ selectedJob?.shipToLocation }}</h3>
                        <div>{{ selectedJob?.billingAddress1 }}</div>
                        <div>{{ selectedJob?.billingAddress2 }}</div>
                        <div>
                            {{ selectedJob?.billingCity?.trim() }}{{ selectedJob?.billingCity && ', ' }}
                            {{ selectedJob?.billingState }}
                            {{ selectedJob?.billingZip }}
                            {{ selectedJob?.shipToCountry }}
                        </div>
                        <div>{{ selectedJob?.shipToPhone }}</div>
                    </div>
                </dxi-item>
            </dxi-item>
        </dx-form>

        <dx-form *ngIf="invoice" [formData]="invoice" [colCount]="2" validationGroup="mainValidationGroup">
            <dxi-item itemType="group" caption="Description">
                <dxi-item [label]="{ text: ' ' }" *ngIf="invoice">
                    <div *dxTemplate>
                        <dx-text-area [(value)]="invoice.description" [height]="100" [readOnly]="readOnly"> </dx-text-area>
                    </div>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Invoice Notes">
                <dxi-item [label]="{ text: ' ' }" *ngIf="invoice">
                    <div *dxTemplate>
                        <dx-text-area [(value)]="invoice.note" [height]="100" [readOnly]="readOnly"> </dx-text-area>
                    </div>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </div>

    <!-- InvoiceLines -->
    <div class="col-sm-12">
        <div class="m-1 grid-fill" style="min-height: 300px">
            <dx-data-grid
                #linesGrid
                *ngIf="lines"
                class="lines-grid"
                keyExpr="id"
                [dataSource]="lines"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="selectionChange($event)"
                (onRowUpdated)="onRowUpdating($event)"
                [showBorders]="true"
                [sorting]="'none'"
            >
                <dxi-column dataField="lineNumber" caption="Line #" [sortIndex]="1" sortOrder="asc" [allowEditing]="false" width="100"></dxi-column>
                <dxi-column dataField="item" [allowEditing]="true" width="115"></dxi-column>
                <dxi-column dataField="description" caption="Description" [allowEditing]="true" width="215"></dxi-column>
                <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" [allowEditing]="!invoice.isReadOnly" width="55"></dxi-column>
                <dxi-column
                    dataField="price"
                    [editorOptions]="{ step: 0 }"
                    caption="Price"
                    width="100"
                    [allowEditing]="!invoice.isReadOnly"
                    alignment="right"
                    [format]="{ type: 'currency', precision: 2 }"
                ></dxi-column>
                <dxi-column dataField="lineTotal" caption="Total" width="120" alignment="right" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
                <dxi-column width="30" [allowEditing]="false"></dxi-column>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button
                    class="btn btn-sm btn-secondary mr-1"
                    (click)="move(linesGrid.instance.getSelectedRowsData()[0], 'up')"
                    [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length !== 1"
                >
                    <i class="fa fa-long-arrow-up" aria-hidden="true"></i>
                </button>
                <button
                    class="btn btn-sm btn-secondary mr-2"
                    (click)="move(linesGrid.instance.getSelectedRowsData()[0], 'down')"
                    [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length !== 1"
                >
                    <i class="fa fa-long-arrow-down" aria-hidden="true"></i>
                </button>
                    <button accesskey="a" class="btn btn-sm btn-success mr-2" (click)="addLines('Replacements')">Add Line</button>
                    <button class="btn btn-sm btn-danger mr-2" (click)="removeLine()" [disabled]="linesGrid.instance.getSelectedRowsData().length === 0">Remove</button>
                </div>
                <dxo-summary>
                    <dxi-total-item column="lineTotal" summaryType="sum" [valueFormat]="{ precision: 2, type: 'currency' }"> </dxi-total-item>
                </dxo-summary>
                <dxo-selection mode="multiple" showCheckBoxesMode="onClick"></dxo-selection>
                <dxo-editing [mode]="'cell'" [allowUpdating]="!invoice.isReadOnly"></dxo-editing>
                <dxo-state-storing [enabled]="true" [storageKey]="'invoice-detail-grid'"></dxo-state-storing>
            </dx-data-grid>
        </div>
    </div>

    <div class="col-sm-6">
        <div class="mt-2 m-1 dataGridOutline" style="min-height: 150px; min-width: 150px; max-width: 400">
            <div style="border-bottom: 2px solid"><h4 class="ml-2">Purchase Orders</h4></div>
            <dx-data-grid
                #dataGrid
                *ngIf="purchaseOrderLines"
                keyExpr="id"
                class="lines-grid"
                [dataSource]="purchaseOrderLines"
                [columnAutoWidth]="false"
                (onSelectionChanged)="selectionChange($event)"
                [showBorders]="true"
                height="250"
            >
                <dxi-column dataField="invoiceDate" caption="Date" width="80"></dxi-column>
                <dxi-column dataField="vendor" caption="Vendor" width="100"></dxi-column>
                <dxi-column dataField="description" caption="Description" width="300"></dxi-column>
                <dxi-column dataField="amount" alignment="left" caption="Amount" width="100">
                    <dxo-format type="currency" precision="2"></dxo-format>
                </dxi-column>

                <dxo-summary>
                    <dxi-total-item column="amount" summaryType="sum" [valueFormat]="{ precision: 2, type: 'currency' }"> </dxi-total-item>
                </dxo-summary>

                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="purchaseOrderLine-search-grid"></dxo-state-storing>
            </dx-data-grid>
        </div>


    </div>

    <!-- Time Entries -->
    <div class="col-sm-3">
        <div class="mt-2 m-1 dataGridOutline" style="min-height: 150px; min-width: 150px; max-width: 400">
            <div style="border-bottom: 2px solid"><h4 class="ml-2">Time</h4></div>
            <dx-data-grid *ngIf="timeEntries" #timeGrid height="250" [dataSource]="timeEntries" keyExpr="id" [columnAutoWidth]="false">
                <dxi-column width="30"></dxi-column>
                <dxi-column dataField="employee.displayName" caption="Employee" width="125"></dxi-column>
                <dxi-column dataField="quantity" caption="Qty" width="85"></dxi-column>
                <dxi-column dataField="created" caption="Date" type="date" width="75"></dxi-column>
                <dxi-column width="10"></dxi-column>
                <dxo-selection mode="none"></dxo-selection>

                <dxo-summary>
                    <dxi-total-item column="quantity" summaryType="sum"> </dxi-total-item>
                </dxo-summary>
            </dx-data-grid>
        </div>
    </div>

    <!-- Materials -->
    <div class="col-sm-3">
        <div class="mt-2 m-1 dataGridOutline" style="min-height: 150px; min-width: 150px; max-width: 400">
            <div style="border-bottom: 2px solid"><h4 class="ml-2">Materials</h4></div>
            <dx-data-grid *ngIf="materials" #materialsGrid height="250" [dataSource]="materials" keyExpr="id" [columnAutoWidth]="false" caption="Materials">
                <dxi-column width="30"></dxi-column>
                <dxi-column dataField="name" caption="Material" width="200"></dxi-column>
                <dxi-column dataField="quantity" caption="Qty" width="65"></dxi-column>
                <dxi-column width="10"></dxi-column>
                <dxo-selection mode="none"></dxo-selection>
                <dxo-summary>
                    <dxi-total-item column="quantity" summaryType="sum"> </dxi-total-item>
                </dxo-summary>
            </dx-data-grid>
        </div>
    </div>
</div>
